<template>
  <Modal :value="value" title="设置安全密码" class="vertical-center-modal" :width="400"
    @on-visible-change="onVisible">
    <Form ref="form" :model="form" :rules="rules" :label-width="80">
      <FormItem label="新密码" prop="newPwd">
        <Input v-model="form.newPwd" type="password" password placeholder="请输入6-15位数字或英文字母的新密码" />
      </FormItem>
      <FormItem label="确认密码" prop="confirmPwd">
        <Input v-model="form.confirmPwd" type="password" password placeholder="请再次输入新密码" />
      </FormItem>
    </Form>
    <template #footer>
      <dialog-footer @cancel="close" @confirm="submit" />
    </template>
  </Modal>
</template>

<script>
export default {
  name: 'SetSafePasswordDialog',
  props: { value: { type: Boolean, default: false } },
  data() {
    const checkConfirm = (rule, val, cb) =>
      val !== this.form.newPwd ? cb(new Error('两次密码不一致')) : cb()
    return {
      form: { newPwd: '', confirmPwd: '' },
      rules: {
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^[A-Za-z\d]{6,15}$/, message: '6-15位数字或英文字母', trigger: 'blur' }
        ],
        confirmPwd: [{ required: true, validator: checkConfirm, trigger: 'blur' }]
      }
    }
  },
  methods: {
    onVisible(v) { if (!v) this.close() },
    close() { this.$refs.form && this.$refs.form.resetFields(); this.$emit('input', false) },
    submit() {
      this.$refs.form.validate((ok) => {
        if (!ok) return
        this.$Message.success('安全密码已设置(待接口)')
        this.close()
      })
    }
  }
}
</script>
